import {
    Button,
    Grid,
    Input,
    Modal,
    Spin,
    Card,
    Typography,
    Row,
    Col,
    Empty,
    Space,
} from "antd";
import React, { useEffect, useState } from "react";
import { useItemsFine } from "../../../_actions/app/items";
import { getPublicImageURL } from "../../../_helpers/image";
import { useCreateItemMutation } from "../../../_actions/app/items";
import log from "cslog";

const { useBreakpoint } = Grid;

const { Search } = Input;
const { Text } = Typography;

function useDebouncedValue(value, delay = 400) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(t);
    }, [value, delay]);
    return debounced;
}

export default function JoinOrganizationModal({
    visible,
    onClose,
    currentUser,
}) {
    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearchTerm = useDebouncedValue(searchTerm, 450);
    const [selectedJoin, setSelectedJoin] = useState(null);
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    const trimmed = debouncedSearchTerm.trim();

    const filterObj = {
        _and: [
            { owner: { _neq: "$CURRENT_USER" } },
            {
                users: {
                    _none: { directus_users_id: { _eq: "$CURRENT_USER" } },
                },
            },
        ],
    };

    if (trimmed.length >= 3) {
        filterObj._and.push({
            name: { _icontains: trimmed },
        });
    } else {
        filterObj._and.push({
            id: { _null: true },
        });
    }

    const filterStr = encodeURIComponent(JSON.stringify(filterObj));
    const queryString = `fields=*,users.*,users.role&filter=${filterStr}`;

    const {
        data: dataJoin,
        isLoading: isLoadingJoin,
        isFetching: isFetchingJoin,
    } = useItemsFine("qdb_organization", queryString, visible);

    const createJoinMutation = useCreateItemMutation();

    useEffect(() => {
        if (!visible) {
            setSearchTerm("");
            setSelectedJoin(null);
        }
    }, [visible]);

    const handleSendRequest = () => {
        if (!selectedJoin || !currentUser) {
            log.e("No selected org or user data", "handleSendRequest");
            return;
        }

        createJoinMutation.mutate(
            {
                collection: "junction_directus_users_qdb_organization",
                data: {
                    directus_users_id: currentUser.id,
                    qdb_organization_id: selectedJoin.id,
                    role: "draft",
                },
            },
            {
                onSuccess: (res) => {
                    console.log(res, "Join request response");
                    onClose();
                },
                onError: (err) => {
                    log.e(err, "join request error");
                    if (err?.response) {
                        log.e(
                            `Status: ${
                                err.response.status
                            }, Data: ${JSON.stringify(err.response.data)}`,
                            "API error"
                        );
                    }
                },
            }
        );
    };

    const modalFooter = selectedJoin
        ? [
              <Button
                  key="cancel"
                  size={isMobile ? "large" : "middle"}
                  onClick={() => setSelectedJoin(null)}
                  disabled={createJoinMutation.isLoading}
              >
                  Cancel
              </Button>,
              <Button
                  key="send"
                  type="primary"
                  size={isMobile ? "large" : "middle"}
                  onClick={handleSendRequest}
                  loading={createJoinMutation.isLoading}
              >
                  Send Request
              </Button>,
          ]
        : null;

    return (
        <Modal
            title="Join an Organization"
            open={visible}
            onCancel={onClose}
            footer={modalFooter}
            width={isMobile ? "100%" : "60%"}
            style={
                isMobile
                    ? { top: 0, margin: 0, maxWidth: "100vw", padding: 0 }
                    : {}
            }
            styles={{
                body: { padding: isMobile ? "16px" : "24px" },
                content: isMobile ? { borderRadius: 0 } : {},
            }}
        >
            <Search
                placeholder="Search for organizations..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onSearch={(val) => setSearchTerm(val)}
                size={isMobile ? "large" : "middle"}
                style={{ marginBottom: 16 }}
                allowClear
            />

            {isLoadingJoin || isFetchingJoin ? (
                <div style={{ textAlign: "center", padding: "40px 0" }}>
                    <Spin tip="Loading organizations..." size="large" />
                </div>
            ) : !dataJoin || dataJoin.length === 0 ? (
                <Empty
                    description={
                        trimmed.length < 3
                            ? "Please enter at least 3 characters to search for organizations."
                            : "No organizations found matching your search."
                    }
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            ) : (
                <Row
                    gutter={[12, 12]}
                    style={{
                        maxHeight: isMobile ? "60vh" : 400,
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                        overscrollBehavior: "contain",
                    }}
                >
                    {dataJoin.map((item) => (
                        <Col
                            key={item.id}
                            xs={12}
                            sm={8}
                            md={6}
                            lg={6}
                            xl={4}
                            style={{ marginBottom: 12 }}
                        >
                            <Card
                                hoverable
                                onClick={() => {
                                    setSelectedJoin(item);
                                }}
                                style={{
                                    height: "100%",
                                    ...(item.id === selectedJoin?.id
                                        ? { border: "2px solid #1890ff" }
                                        : {}),
                                }}
                                styles={{
                                    body: {
                                        padding: 12,
                                        textAlign: "center",
                                    },
                                }}
                            >
                                <img
                                    src={getPublicImageURL(item.logo)}
                                    alt={item.name}
                                    style={{
                                        width: "100%",
                                        height: 60,
                                        objectFit: "contain",
                                    }}
                                />

                                <Space
                                    direction="vertical"
                                    align="center"
                                    size={4}
                                >
                                    <Text>{item.name}</Text>
                                    <Text type="secondary">Available</Text>
                                </Space>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}
        </Modal>
    );
}
